import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";

import useSystemsDataHandler from "hooks/useSystemsDataHandler";

import { getSideNavItems } from "./SideNavItems";

import "./SideNavContent.scss";
import "./SideNavItem.scss";

const SideNavContent = props => {
  const location = useLocation();
  const { getSystemId } = useSystemsDataHandler();
  const { isAdmin, isTier1, isTier2 } = useSelector(state => state.user);

  let [sideNavItems, setSideNavItems] = useState([]);

  useEffect(() => {
    const { pathname } = location;
    const paths = pathname.split("/");
    const page = paths[3];
    if (!sideNavItems.length) {
      const sysId = getSystemId();
      sideNavItems = getSideNavItems(isAdmin, isTier1, isTier2, sysId);
    }
    sideNavItems = sideNavItems.map(item => ({ ...item, isActive: item.relativePath === page }));
    setSideNavItems(sideNavItems);
  }, [location]);

  const { systemsStatus, systemId } = props;

  return (
    <div className="side-nav-content paleGrayBackground">
      <ul className="side-nav__list">
        {sideNavItems.map(
          item =>
            item.visible && (
              <li className="sidenav-tab__listitem" key={item.relativePath}>
                <div className={item.isActive ? "sidenav-active-tab__border" : "no-border"}>.</div>
                <NavLink to={item.relativePath} className="sideNavItem">
                  {React.createElement(item.icon, { active: item.isActive })}
                  <div className={`sidenav-tab__listitem--name ${item.isActive ? "active" : ""}`}>{item.name}</div>
                </NavLink>
              </li>
            )
        )}
      </ul>
    </div>
  );
};

export default SideNavContent;
